/**
 * DV-2856 (decision D4): "Show Image Details" persists per user, so someone
 * who works with Image IDs gets them on every visit instead of re-flipping the
 * toggle. localStorage, not sessionStorage — the point is that it survives the
 * session. Not org-scoped: it is a display preference about the person, not
 * about the account they happen to be in, so it deliberately stays out of
 * clearOrgScopedDrafts().
 *
 * Both accessors are guarded: Safari private mode throws on localStorage
 * access, and a view preference must never take the page down with it.
 */
export const IMAGE_DETAILS_STORAGE_KEY = 'pmc:assets:show-image-details';

export function readShowImageDetails(): boolean {
  try {
    return localStorage.getItem(IMAGE_DETAILS_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeShowImageDetails(value: boolean): void {
  try {
    localStorage.setItem(IMAGE_DETAILS_STORAGE_KEY, String(value));
  } catch {
    // Storage denied or full: the toggle still works for this session (the
    // slice holds it), it just won't be remembered. Nothing to report.
  }
}
